import { render, staticRenderFns } from "./BatchInquiryReport.vue?vue&type=template&id=0d39f717"
import script from "./BatchInquiryReport.vue?vue&type=script&lang=js"
export * from "./BatchInquiryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports